import type { FlightContext } from "@checkout/index";
import {
  FlightSelectors,
  getObjectKeysAsObject,
  ParentState,
} from "@hopper-b2b/checkout";
import { getIsFixedPriceFromBasePrice } from "@/utilities/rewards/pricing";

export const guards = {
  isFlightsFixedPointsPurchase: (
    context: FlightContext,
    _event: unknown
  ): boolean => {
    const tripPricing = FlightSelectors.getPricing({
      context,
    });

    const totalPricing = tripPricing?.totalPricing;
    if (!totalPricing?.baseWithoutMargin) {
      return false;
    }

    const rewardsAccountId =
      context[ParentState.awardsPayment]?.rewardsAccountId ?? "";

    if (!rewardsAccountId) {
      return false;
    }

    const isFixedPrice = getIsFixedPriceFromBasePrice(
      totalPricing.baseWithoutMargin,
      rewardsAccountId
    );

    return isFixedPrice;
  },
};
export const GuardTypes = getObjectKeysAsObject(guards);
